"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWidgetToPanel = void 0;
const index_1 = require("../../commands/index");
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const add_widget_panel_1 = require("../../commands/common/add_widget_panel");
exports.addWidgetToPanel = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { widgetId, resourceId, resourceType } = options;
        const widgetPanels = (0, selectors_1.getResourceWidgetPanels)(state, resourceId, resourceType);
        let panelIndex = 0;
        let installationIndex = 0;
        const actions = [];
        if (!widgetPanels || !widgetPanels.length) {
            // The first time you install a widget, you need to install a panel first
            const rct = add_widget_panel_1.addWidgetPanel.execute(context, {
                cmd: index_1.CollaCommandName.AddWidgetPanel,
                resourceId,
                resourceType
            });
            if (rct && rct.result !== command_manager_1.ExecuteResult.Fail) {
                actions.push(...rct.actions);
            }
        }
        else {
            const widgetPanelStatus = (0, selectors_1.getResourceWidgetPanelStatus)(state, resourceId, resourceType);
            const activePanelId = (widgetPanelStatus === null || widgetPanelStatus === void 0 ? void 0 : widgetPanelStatus.activePanelId) || widgetPanels[0].id;
            panelIndex = widgetPanels.findIndex(item => item.id === activePanelId);
            if (panelIndex < 0) {
                return null;
            }
            installationIndex = widgetPanels[panelIndex].widgets.length;
        }
        const addWidgetToPanelAction = resourceType === types_1.ResourceType.Datasheet ?
            model_1.DatasheetActions.addWidgetToPanel2Action(state, { installationIndex, panelIndex, widgetId }) :
            model_1.DatasheetActions.addWidgetToPanelWithMirror2Action(state, { installationIndex, panelIndex, widgetId });
        if (!addWidgetToPanelAction) {
            return null;
        }
        actions.push(...addWidgetToPanelAction);
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: resourceId,
            resourceType: resourceType,
            actions: actions,
        };
    },
};
//# sourceMappingURL=add_widget_to_panel.js.map